import { render, staticRenderFns } from "./addClientNotes.vue?vue&type=template&id=3bd41549"
import script from "./addClientNotes.vue?vue&type=script&lang=js"
export * from "./addClientNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports